import { createElement, useContext } from '@wordpress/element'
import { __ } from 'ct-i18n'
import cls from 'classnames'
import DraggableItems from './DraggableItems'
import { PanelContext } from '../../../options/components/PanelLevel'

const Bar = ({ bar, builderValue, direction = 'horizontal' }) => {
	const { panelsHelpers } = useContext(PanelContext)

	const maybeValues = builderValue.items[bar.id]
	const allItems = ct_customizer_localizations.header_builder_data.footer

	const primaryItem = allItems.find(({ id }) => id === bar.id)

	const values = maybeValues ? maybeValues.values : {}

	let columns = 'initial'

	if (bar.columns.length === 2) {
		columns = values['2_columns_layout'] || {
			desktop: 'repeat(2, 1fr)',
			tablet: 'initial',
			mobile: 'initial',
		}
	}

	if (bar.columns.length === 3) {
		columns = values['3_columns_layout'] || {
			desktop: 'repeat(3, 1fr)',
			tablet: 'initial',
			mobile: 'initial',
		}
	}

	if (bar.columns.length === 4) {
		columns = values['4_columns_layout'] || {
			desktop: 'repeat(4, 1fr)',
			tablet: 'initial',
			mobile: 'initial',
		}
	}

	if (bar.columns.length === 5) {
		columns = values['5_columns_layout'] || {
			desktop: 'repeat(5, 1fr)',
			tablet: 'initial',
			mobile: 'initial',
		}
	}

	if (bar.columns.length === 6) {
		columns = values['6_columns_layout'] || {
			desktop: 'repeat(6, 1fr)',
			tablet: 'initial',
			mobile: 'initial',
		}
	}

	if (columns && columns.desktop) {
		columns = columns.desktop
	}

	return (
		<li className="builder-row">
			<div
				className="ct-row-actions"
				onClick={() => panelsHelpers.open(`builder_panel_${bar.id}`)}>
				{
					{
						'top-row': __('Top Row', 'blocksy'),
						'middle-row': __('Middle Row', 'blocksy'),
						'bottom-row': __('Bottom Row', 'blocksy'),
					}[bar.id]
				}
			</div>

			<ul
				className="row-inner"
				style={{
					'--gridTemplateColummns': columns,
				}}>
				{bar.columns.map((column, index) => (
					<li className="builder-column" key={index}>
						<DraggableItems
							draggableId={`${bar.id}:${index}`}
							items={column}
						/>
					</li>
				))}
			</ul>
		</li>
	)
}

const shallowCompare = (prev, next) => {
	for (let key in next) {
		if (next[key] !== prev[key]) return false
	}

	return true
}

export function memo(Component, areEqual = shallowCompare) {
	let prevProps = {}
	let prevResult
	return (nextProps) => {
		if (prevResult !== undefined && areEqual(prevProps, nextProps)) {
			return prevResult
		}

		prevProps = nextProps
		prevResult = createElement(Component, Object.assign({}, nextProps))

		return prevResult
	}
}

const ColumnsBuilder = memo(({ builderValue }) => (
	<div className={cls('placements-builder')}>
		<ul className="horizontal-rows">
			{['top-row', 'middle-row', 'bottom-row'].map((bar) => (
				<Bar
					builderValue={builderValue}
					bar={builderValue.rows.find(({ id }) => id === bar)}
					key={bar}
				/>
			))}
		</ul>
	</div>
))

// const ColumnsBuilder = () => null

export default ColumnsBuilder
